app.service("MethodProductService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const MethodProductModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Method Product",
        id: "method_product",
        navigation_pointer: "method_product_id",
        show_with_children: true,
        next_model_id: "tab"
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            matrix: new RouteChoice({
                name: "Matrix"
            }),
            list: new RouteChoice({
                name: "list"
            }),
        },

        birth: function (values) {
            return new MethodProductModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const browseID = variationIDs.browse_id;
        const tabID = variationIDs.tab_id;
        const doorTypeID = variationIDs.door_type_id;

        let choiceOrder;
        if (browseID === "component") {
            choiceOrder = ['matrix'];
        } else if (tabID === "robe" && ["sliding", "bifold"].includes(doorTypeID)) {
            choiceOrder = ['list'];
        } else {
            choiceOrder = ['matrix', 'list']
        }


        model.choice_order = choiceOrder;
        model.default_choice_id = choiceOrder[0];

        if (tabID) {
            model.next_model_id = "collection_product";
        }

    }

}]);